<template>
    <div>
        <input type="file" class="form-control my-2" @change="handleProfile">
        <button @click="uploadPicture">Upload Profile picture</button>
    </div>
</template>
<script>
import axios from 'axios'
export default{
    
    data(){
        return{
      profilepicture:"",
      userid:""
        }
    },
    mounted(){
this.userid=JSON.parse(localStorage.getItem('honeyuserid'))
    },
   methods:{
    
    handleProfile(e){
  this.profilepicture=e.target.files[0]
    },
    uploadPicture(){
 const post=new FormData()
        post.append('student_id',this.userid)
        // post.append('content',this.content)
        post.append('image',this.profilepicture)

    //   let post={
    //     student_id:this.userid,
    //     content:this.content

    //   }  
       axios.post('http://127.0.0.1:8000/api/studentprofilepicture',post,{
        headers:{
            'Content-Type':'multipart/form-data'
        }
       })
       .then((res)=>{
        console.log(res.data)
       })
       .catch((err)=>{
        console.log(err)
       })
    }
} 
}
</script>